
import "./donationFooter.css";

export function DonationFooter() { 

    return (
        <div className="donationFooterContainer">
            <img src={`${process.env.PUBLIC_URL}/footer.jpeg`} alt="Mandir Logo" className="mandir-logo" />
        </div>
    );
}